import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authApi } from '@/services/api/authApi';
import { useAuthStore } from '@/stores/authStore';
import { LoadingSpinner, ErrorMessage } from '@/components/ui';

const MagicLinkPage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const { loginWithTokens, setUser } = useAuthStore();
  const [error, setError] = useState<string | null>(null);
  const processed = useRef(false);

  useEffect(() => {
    if (!token || processed.current) return;
    processed.current = true;

    const authenticate = async () => {
      try {
        const tokenResponse = await authApi.magicLink(token);
        loginWithTokens(tokenResponse);
        const user = await authApi.getMe();
        setUser(user);
        toast.success('Вход выполнен');
        navigate('/my-orders', { replace: true });
      } catch {
        setError('Ссылка недействительна или истекла');
      }
    };

    authenticate();
  }, [token, loginWithTokens, setUser, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <ErrorMessage
          message={error}
          onRetry={() => navigate('/login')}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-sm text-gray-500">Выполняем вход...</p>
    </div>
  );
};

export default MagicLinkPage;
